exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating .aaaa{fill:#fff;stroke:#707070}.rating .bbbb{-webkit-clip-path:url(#aaaa);clip-path:url(#aaaa)}.rating .cccc{fill:#ffe165}.rating .dddd{fill:#ffd839}.rating .eeee{fill:#ff9811}.rating .ffff{fill:#ffaf46}.rating .gggg{fill:#ffcd00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b82d42f","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/itemRating.vue
// module id = 1053
// module chunks = 0